export function sumSafe(values) {
  return values.reduce((acc, v) => acc + (Number(v) || 0), 0)
}

export function groupByCliente(dadosClientes) {
  // Agrupa primeiro por CLIENTE e depois por NOTA para evitar duplicidade
  const clients = new Map()
  dadosClientes?.forEach((item, idx) => {
    const cliente = item?.Cliente || item?.cliente || item?.CLIENTE || 'N/I'
    const nota = item?.nota || item?.Nota || item?.NOTA || `${idx}`
    const volumes = Number(item?.VOLUMES || item?.volumes || 0)
    const peso = Number(item?.PESO || item?.peso || 0)
    const m3 = Number(item?.M3 || item?.m3 || 0)
    const etiquetas = Number(item?.etiquetas || item?.ETIQUETAS || 0)
    const statusEtiqueta = item?.STATUS_ETIQUETA
    const impressa = statusEtiqueta === 1 || statusEtiqueta === '1' || item?.etiquetaImp === true

    if (!clients.has(cliente)) clients.set(cliente, new Map())
    const notes = clients.get(cliente)
    if (!notes.has(nota)) notes.set(nota, { volumes: 0, peso: 0, m3: 0, etiquetas: 0, impressa: false, _fixed: false })
    const n = notes.get(nota)

    // Volumes/Peso/M3 devem vir do PRIMEIRO registro da NOTA
    if (!n._fixed) {
      n.volumes = volumes || 0
      n.peso = peso || 0
      n.m3 = m3 || 0
      n._fixed = true
    }

    // Para etiquetas, evitar duplicidade por VOLUMES: usar o maior valor visto para a mesma NOTA
    n.etiquetas = Math.max(n.etiquetas, etiquetas || 0)
    // Status de impressão: se qualquer registro da NOTA estiver impresso, considerar impresso
    n.impressa = n.impressa || impressa
  })

  // Consolida por CLIENTE
  const result = []
  clients.forEach((notesMap, cliente) => {
    let notasCount = 0
    let volumes = 0
    let peso = 0
    let m3 = 0
    let etiquetasImp = 0
    let etiquetasSem = 0
    let naoImpressas = 0

    notesMap.forEach((note) => {
      notasCount += 1
      volumes += Number(note.volumes) || 0
      peso += Number(note.peso) || 0
      m3 += Number(note.m3) || 0
      const etiquetasVal = note.etiquetas || 1
      if (note.impressa) {
        etiquetasImp += etiquetasVal
      } else {
        etiquetasSem += etiquetasVal
        naoImpressas += 1
      }
    })

    result.push({ cliente, notas: notasCount, volumes, peso, m3, etiquetasImp, etiquetasSem, naoImpressas })
  })

  return result
}

export function groupByCdPracaCliente(dadosClientes) {
  const cds = {}
  dadosClientes?.forEach((item, idx) => {
    const cd = item?.CD || item?.cd || 'N/I'
    const praca = item?.Praca || item?.praca || 'N/I'
    const cliente = item?.Cliente || item?.cliente || 'N/I'
    const peso = Number(item?.PESO || item?.peso || 0)
    const volumes = Number(item?.VOLUMES || item?.volumes || 0)
    const m3 = Number(item?.M3 || item?.m3 || 0)
    const etiquetas = Number(item?.etiquetas || item?.ETIQUETAS || 0)
    const nota = item?.nota || item?.NOTA || `${idx}`

    cds[cd] = cds[cd] || { key: cd, cd, peso: 0, volumes: 0, m3: 0, etiquetas: 0, notas: new Set(), children: {} }
    const cdNode = cds[cd]
    cdNode.peso += peso
    cdNode.volumes += volumes
    cdNode.m3 += m3
    cdNode.etiquetas += etiquetas
    cdNode.notas.add(nota)

    cdNode.children[praca] = cdNode.children[praca] || { key: `${cd}-${praca}`, cd, praca, peso: 0, volumes: 0, m3: 0, etiquetas: 0, notas: new Set(), children: {} }
    const prNode = cdNode.children[praca]
    prNode.peso += peso
    prNode.volumes += volumes
    prNode.m3 += m3
    prNode.etiquetas += etiquetas
    prNode.notas.add(nota)

    prNode.children[cliente] = prNode.children[cliente] || { key: `${cd}-${praca}-${cliente}`, cd, praca, cliente, peso: 0, volumes: 0, m3: 0, etiquetas: 0, notas: new Set() }
    const clNode = prNode.children[cliente]
    clNode.peso += peso
    clNode.volumes += volumes
    clNode.m3 += m3
    clNode.etiquetas += etiquetas
    clNode.notas.add(nota)
  })

  const cdsArr = Object.values(cds).map((cdNode) => ({
    ...cdNode,
    notas: cdNode.notas.size,
    children: Object.values(cdNode.children).map((prNode) => ({
      ...prNode,
      notas: prNode.notas.size,
      children: Object.values(prNode.children).map((clNode) => ({
        ...clNode,
        notas: clNode.notas.size,
      })),
    })),
  }))

  return cdsArr
}

export function groupByImpressoraVeiculoCliente(dadosClientes) {
  const printers = {}
  dadosClientes?.forEach((item, idx) => {
    const impressora = item?.impressora || item?.IMPRESSORA || item?.printer || 'N/I'
    const veiculo = item?.CARRO || item?.veiculo || item?.VEICULO || 'N/I'
    const cliente = item?.Cliente || item?.cliente || 'N/I'
    const etiquetas = Number(item?.etiquetas || item?.ETIQUETAS || 0)
    const volumes = Number(item?.VOLUMES || item?.volumes || 0)
    const peso = Number(item?.PESO || item?.peso || 0)
    const m3 = Number(item?.M3 || item?.m3 || 0)
    const nota = item?.nota || item?.NOTA || `${idx}`

    printers[impressora] = printers[impressora] || { key: impressora, impressora, etiquetas: 0, volumes: 0, peso: 0, m3: 0, notas: new Set(), children: {} }
    const p = printers[impressora]
    p.etiquetas += etiquetas
    p.volumes += volumes
    p.peso += peso
    p.m3 += m3
    p.notas.add(nota)

    p.children[veiculo] = p.children[veiculo] || { key: `${impressora}-${veiculo}`, impressora, veiculo, etiquetas: 0, volumes: 0, peso: 0, m3: 0, notas: new Set(), children: {} }
    const v = p.children[veiculo]
    v.etiquetas += etiquetas
    v.volumes += volumes
    v.peso += peso
    v.m3 += m3
    v.notas.add(nota)

    v.children[cliente] = v.children[cliente] || { key: `${impressora}-${veiculo}-${cliente}`, impressora, veiculo, cliente, etiquetas: 0, volumes: 0, peso: 0, m3: 0, notas: new Set() }
    const c = v.children[cliente]
    c.etiquetas += etiquetas
    c.volumes += volumes
    c.peso += peso
    c.m3 += m3
    c.notas.add(nota)
  })

  const pArr = Object.values(printers).map((p) => ({
    ...p,
    notas: p.notas.size,
    children: Object.values(p.children).map((v) => ({
      ...v,
      notas: v.notas.size,
      children: Object.values(v.children).map((c) => ({
        ...c,
        notas: c.notas.size,
      })),
    })),
  }))

  return pArr
}